import { track } from "@amplitude/analytics-react-native";
import { memo } from "react";
import { View } from "react-native";
import { amp } from "src/api/amplitude";
import promotion_background from "src/assets/images/promotion_background.png";
import RoundedButton from "src/components/RoundedButton";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useClientProfile from "src/hooks/useClientProfile";
import { radiusSmall } from "src/styles/radius";
import { paddingMedium } from "src/styles/spacing";
import { Image, Text } from "src/swsh-native";
import { CreateGatheringPromptCardProps } from "./types";

const CreateGatheringPromptCard = ({ width, height }: CreateGatheringPromptCardProps) => {
	const { profile } = useClientProfile();
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	// TODO: Remove after EDC. Very hacky implementation.
	const isEdc = gatheringId.startsWith("06ec2971");

	if (!profile || !profile.firstName) {
		return (
			<View
				style={{
					width,
					height,
				}}
			/>
		);
	}
	const eventName = isEdc
		? `${profile.firstName}'s EDC Las Vegas Memories`
		: `${profile.firstName}'s Night Out`;
	const handlePress = () => {
		track(amp.gathering.inlineCreateClick, {
			isEdc,
		});
	};
	const isLarge = width > 220;
	return (
		<View
			testID="CreatePromptCard"
			style={{
				width,
				height,
				alignItems: "center",
				justifyContent: "flex-end",
				overflow: "hidden",
				paddingHorizontal: paddingMedium,
				paddingBottom: paddingMedium,
				borderRadius: radiusSmall,
			}}
		>
			<Image
				alt="Create Prompt"
				src={promotion_background}
				dim={{
					width,
					height,
				}}
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
				}}
			/>
			<View
				style={{
					minHeight: "38%",
					gap: paddingMedium,
				}}
			>
				<View
					style={{
						flex: 1,
						justifyContent: "center",
					}}
				>
					<Text
						bold
						semiLarge={isLarge}
						small={!isLarge}
						style={{
							textAlign: "center",
						}}
					>
						{eventName}
					</Text>
				</View>
				<RoundedButton
					href={`/create?name=${encodeURIComponent(eventName)}`}
					colorVariant="Primary"
					sizeVariant="Skinny"
					onPress={handlePress}
					containerStyle={{
						bottom: 0,
					}}
				>
					Create album
				</RoundedButton>
			</View>
		</View>
	);
};
export default memo(CreateGatheringPromptCard);
